<template>
  <v-app :style="{background: this.$vuetify.theme.themes.light.background}">
    <v-content>
        <v-container class="fill-height" fluid>
          <v-row justify="center" align="center">
            <v-card>
              <v-card-title>
                404 - ページが見つかりません
              </v-card-title>
              <v-card-actions>
                <v-spacer/>
                <v-btn small color="primary" :to="{name: 'Landing'}">
                  <v-icon>mdi-image-filter-drama</v-icon>トップページへ
                </v-btn>
              </v-card-actions>
            </v-card>            
          </v-row>
        </v-container>
    </v-content>
  </v-app>
</template>

<script>
  export default {
    name: "NotFound",
    data: () => ({
        
    })
  };
</script>